






































































































































































































































import { Vue, Component, Mixins } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import { EStateColor } from '@/typings/enum'
import { ISpecialDisplay } from '@/api/content/content-special/res'
import {
  addEditSpecailLib,
  getSpecialDetail,
  changeAppSeq,
  addEditSpecial
} from '@/api/content/content-special/special'
import { getLangType } from '@/api/common'
import {
  deepCopy,
  isUniqueStringArray,
  findIndexOfObj,
  checkNoneString,
  resetObjValue2NoneString,
  frontMove,
  backMove
} from '@/utils/tool'
import { getIosList, getAndroidList } from '@/api/files/files-app/filesApp'
import Editor from '@/components/Editor/editor.vue'

const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'NewsAdd',
  components: {
    Editor
  }
})
export default class extends Mixins(DisplayMixin) {
  private params: any = {
    specialId: 0,
    defaultLang: '',
    name: '',
    icon: '',
    desc: '',
    isIos: 1, // 1：ios 3：android
    descList: [],
    appData: ''
  }
  private stateColor = EStateColor
  private tableData: any[] = []
  private langList: any[] = []
  private multiLanguage: any[] = []
  currentParams: any = {
    name: '',
    lang: '',
    icon: '',
    desc: ''
  }
  currentLang: string = ''
  paramsList: any = {}
  // lifecycle
  async created() {
    let p = this.$route.query.platform
    this.params.isIos = p === 'ios' ? 1 : 3
    await this.getLangType()
    if (this.$route.query.id && +this.$route.query.id > 0) {
      await this.getSpecialLibInfo()
    }
  }
  // methods
  async getLangType() {
    let res = await getLangType()
    this.langList = res.data
  }
  handleSelect(val: string[]) {
    if (val.length > 0) {
      this.currentLang = val[0]
    } else {
      this.currentLang = ''
    }
    let obj: any = {}
    for (let code of val) {
      if (this.paramsList[code]) {
        obj[code] = this.paramsList[code]
      } else {
        obj[code] = {
          name: '',
          lang: code,
          icon: '',
          desc: ''
        }
      }
    }
    this.paramsList = obj
    console.log(this.paramsList)
    this.currentParams = { ...this.paramsList[this.currentLang] }
  }
  handleLanguageChange(code: string) {
    this.paramsList[this.currentLang] = { ...this.currentParams }
    this.currentLang = code
    if (this.paramsList[code]) {
      this.currentParams = { ...this.paramsList[code] }
    } else {
      this.currentParams = {
        name: '',
        desc: '',
        icon: '',
        lang: ''
      }
    }
  }
  async getSpecialLibInfo() {
    let res: any = await getSpecialDetail({
      id: this.$route.query.id
    })
    if (res.status.code === 0) {
      let obj: any = res.data
      this.params.specialId = obj.specialId
      this.params.defaultLang = obj.defaultLang
      this.params.name = obj.name
      this.params.desc = obj.desc
      this.params.icon = obj.icon
      console.log(obj.descList)
      // 表格
      this.multiLanguage = obj.descList.map((item: any) => item.lang)
      let [ahead] = obj.descList
      let object: any = {}
      for (let item of obj.descList) {
        const { lang, desc, icon, name } = item
        object[(item as any)['lang']] = { lang, desc, icon, name }
      }
      this.paramsList = object
      if (ahead) {
        const { lang, desc, icon, name } = ahead
        this.currentLang = lang
        this.currentParams = {
          desc,
          icon,
          name,
          lang
        }
      }
      let ids = deepCopy(obj.appData)
        .reduce((prev: any, cur: any) => {
          return cur.entityId + ',' + prev
        }, '')
        .slice(0, -1)
      ids = ids
        .split(',')
        .reverse()
        .join(',')
      this.getAppList(ids)
    } else {
      this['$message'].error('无法获取专题信息')
    }
  }
  async getAppList(ids: string) {
    let res: any
    let specialId = this.params.specialId
    if (this.platform === 'ios') {
      res = await getIosList({ id: ids, specialId: specialId })
    } else {
      res = await getAndroidList({ id: ids, specialId: specialId })
    }
    if (res.data.dataList.length === 0) {
      this['$message'].warning('没有此应用信息!')
      return
    }
    let t: any[] = res.data.dataList
    if (this.tableData.length === 0) {
      this.tableData = res.data.dataList
      // console.log(this.tableData)
    } else {
      // 不为空, 重复 id 需判断
      let t1 = this.tableData.map(item => item.id)
      let t2 = t.map(item => item.id)
      let isUnique =
        t1.length + t2.length === [...new Set([...t1, ...t2])].length
      if (isUnique) {
        this.tableData = [...this.tableData, ...t]
      } else {
        this['$message'].error('列表中已添加此id应用')
      }
    }
  }
  async addEditSpecailLib() {
    console.log(this.paramsList)
    const arr = Object.keys(this.paramsList).map((lang: string) => this.paramsList[lang])
    this.params.descList = arr
    let p = { ...this.params }
    p.appData = this.tableData.map(item => ({ entityId: item.id, appName: item.name }))
    console.log(p)
    let res: any = await addEditSpecial(p)
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
      this.handleCancel()
    } else {
      this['$message'].error('操作失败')
    }
  }

  async handleEdit(item: any) {
    const { id, seq } = item
    console.log({ id, seq })
    if (typeof seq === 'string' && seq === '') {
      this['$message'].warning('请输入排序!')
      return false
    } else if (seq <= 0) {
      this['$message'].warning('排序不得小于等于0!')
      return false
    }
    let specialId = this.params.specialId
    console.log(id, seq, specialId)
    let res: any = await changeAppSeq({
      specialId: specialId,
      entityId: id,
      seq: Number(seq)
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
      // console.log(this.tableData)
      let tableData = [...this.tableData]
      tableData = tableData.sort((a, b) => a.seq - b.seq)
      console.log(tableData)
      this.tableData = tableData
    } else {
      this['$message'].error('操作失败')
    }
  }
  handleAdd() {
    // 判空, 判重
    if (this.params.appData === '') return
    if (this.params.appData.includes(',')) {
      let t: any[] = this.params.appData.split(',')
      if (isUniqueStringArray(t)) {
        this['$message'].error('不能输入相同id')
        return
      }
    }
    this.getAppList(this.params.appData)
  }
  removeApp(item: any) {
    let i = findIndexOfObj(item, this.tableData)
    this.tableData.splice(i, 1)
  }
  setTopApp(item: any) {
    let i = findIndexOfObj(item, this.tableData)
    this.tableData.splice(0, 1, ...this.tableData.splice(i, 1, this.tableData[0]))
  }
  setBottomApp(item: any) {
    let i = findIndexOfObj(item, this.tableData)
    let len = this.tableData.length - 1
    this.tableData.splice(len, 1, ...this.tableData.splice(i, 1, this.tableData[len]))
  }
  setUpApp(index: number) {
    frontMove(this.tableData, index)
  }
  setDownApp(index: number) {
    backMove(this.tableData, index)
  }
  handleSubmit() {
    this.paramsList[this.currentLang] = this.currentParams
    let defaultLang: string = this.multiLanguage[0]
    const obj = this.paramsList[defaultLang]
    this.params.defaultLang = defaultLang
    this.params.name = obj.name
    this.params.icon = obj.icon
    this.params.desc = obj.desc
    let isNone = checkNoneString(this.params, [
      'specialId',
      'isIos',
      'appData'
    ])
    console.log(this.params)
    let leng = this.tableData.length
    if (isNone || leng === 0) {
      return this['$message'].warning('请填写完成后再提交')
    } else {
      this.addEditSpecailLib()
    }
  }
  handleCancel() {
    this['$router'].push({ name: this.params.isIos === 1 ? 'ContentSpecialLibIos' : 'ContentSpecialLibAndroid' })
  }
  addLang() {
    let query: IQuery = {
      id: this.params.specialId,
      platform: this.$route.query.platform
    }
    this['$router'].push({
      name: 'ContentSpecialTranslate',
      query: query
    })
  }
  // computed
  get imgType() {
    return this.params.isIos === 1 ? 1 : 2
  }
  get platform() {
    return this.$route.query.platform || 'ios'
  }
  get selectedLanguages() {
    return this.langList.filter((item: any) => this.multiLanguage.includes(item.code))
  }
}
